import type { Driver } from '#domain/model/Driver.ts';
import type { Tour } from '#domain/model/Tour.ts';
import { filterStopInSearch } from '#utils/searchUtils.ts';

const containsSearchTerm = ({ tour, drivers, search }: { tour: Tour; drivers?: Driver[]; search: string }) => {
    const text = search.trim().toLowerCase();
    return (
        tour.truck.licensePlate?.toLowerCase().includes(text) ||
        tour.trailer.licensePlate?.toLowerCase().includes(text) ||
        drivers
            ?.find(driver => driver?.id === tour?.driverId)
            ?.name?.toLowerCase()
            .includes(text) ||
        tour.transportOrders.some(order => order.secondary_reference_id?.toLowerCase().includes(text)) ||
        tour.id?.toLowerCase().includes(text) ||
        tour.truck.id?.toLowerCase().includes(text) ||
        tour.searchName?.toLowerCase().includes(text) ||
        filterStopInSearch(text, tour.firstStop) ||
        filterStopInSearch(text, tour.lastStop)
    );
};

const containsFilterTerm = (item: Tour, statusFilter: string[]) =>
    statusFilter.length === 0 || statusFilter.includes(item.status);

export const useFilteredTours = ({
    tours,
    drivers,
    search,
    statusFilter,
    selectedTourId,
}: {
    tours: Tour[];
    drivers?: Driver[];
    search: string;
    statusFilter: string[];
    selectedTourId?: string;
}) => {
    const filtered = tours
        .filter(tour => containsSearchTerm({ tour, drivers, search }))
        .filter(tour => containsFilterTerm(tour, statusFilter));
    const activeTour = tours.find(item => item.id === selectedTourId);

    return {
        filteredTours: filtered,
        activeTour,
    };
};
